export default __webpack_public_path__ + "static/media/shaban_2.c2354276.jpg";